<template>
  <v-app
    v-if="user"
    ref="mainApp"
    style="min-height: 100vh;"
    class="transparent"
  >
    <TopHeader
      v-if="!$vuetify.breakpoint.xsOnly"
      :focus-mode="focusMode"
      @toggle-focus-mode="toggleFocusMode"
    />

    <Header
      v-show="!focusMode"
      :app-url="appUrl"
      :user="user"
      :workspaces="allowedWorkspaces"
      :active-workspace="activeWorkspace"
      @update-workspace="changeCurrentWorkspace"
    />

    <v-main
      class="relative"
      :class="{ 'pt-0' : focusMode }"
    >
      <!-- <v-progress-linear v-if="loading" indeterminate color="primary" /> -->
      <!--
        <div v-if="error">
          <v-card class="ma-6" color="error" rounded="lg" outlined elevation="4">
            <v-card-text class="white--text text-h6">
              <div>
                Une erreur s'est produite, actualisez la page et réessayez. Si l´erreur persiste, contactez l´équipe de développement.
              </div>
            </v-card-text>
          </v-card>
          <v-card v-if="enviroment === 'test'" class="ma-6" color="error" rounded="lg" outlined elevation="4">
            <v-card-text class="white--text text-h6">
              Dev info:
              <p class="pl-6">{{ error }}</p>
            </v-card-text>
          </v-card>
        </div>
        <div v-else-if="!allowedWorkspaces.length">
          <v-card class="ma-6" color="primary" rounded="lg" outlined elevation="4">
            <v-card-text class="white--text text-h6">
              <div>
                Vous n'avez pas les autorisations pour les espaces de travail disponibles.
              </div>
            </v-card-text>
          </v-card>
        </div>
      -->

      <router-view />
    </v-main>

    <Footer />

    <!-- <BottomNavigationV2 v-if="$route.meta.showBottomNavigationV2" /> -->
    <!-- <template v-else> -->
    <BottomNavigation
      v-show="!focusMode"
      :active-content-type="activeContentType"
    />
    <!-- </template> -->

    <Snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :text="snackbar.text"
      :timeout="snackbar.timeout"
      @close-snackbar="resetSnackbar"
    />

    <Dialog
      v-model="dialog.show"
      @close-dialog="resetDialog"
    />
  </v-app>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';

import TopHeader from '@/components/master/TopHeader.vue';
import Header from '@/components/master/Header.vue';
import BottomNavigation from '@/components/master/BottomNavigation.vue';
// import BottomNavigationV2 from '@/components/master/BottomNavigationV2.vue';
import Footer from '@/components/master/Footer.vue';
import Snackbar from '@/components/master/Snackbar.vue';
import Dialog from '@/components/master/Dialog.vue';

export default {
  name: 'MasterLayout',
  components: {
    TopHeader,
    Header,
    BottomNavigation,
    // BottomNavigationV2,
    Snackbar,
    Dialog,
    Footer
  },
  data () {
    return {
      enviroment: process.env.VUE_APP_ENVIROMENT,
      error: null,
      loaded: true
    };
  },
  computed: {
    ...mapState([
      'user',
      'activeContentType',
      'activeWorkspace',
      'activeBrand',
      'appUrl',
      'loading',
      'focusMode',
      'snackbar',
      'dialog'
    ]),
    ...mapGetters([
      'allowedWorkspaces'
    ])
  },
  watch: {
    activeWorkspace: {
      immediate: true,
      handler (_, oldValue) {
        if (oldValue) return;

        const loader = document.getElementById('app-loader');
        if (loader) {
          loader.style.display = 'none';
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'updateWorkspace'
    ]),
    ...mapMutations([
      'setActiveBrand',
      'toggleFocusMode',
      'resetSnackbar',
      'resetDialog',
      'setTotal',
      'setItems',
      'setItemsByPage',
      'setFilters',
      'setFiltersToKeep',
      'setUser'
    ]),
    async changeCurrentWorkspace (workspace) {
      let route = await this.updateWorkspace(workspace);

      if (![this.$store.state.centralizedWorkspace, 'spontaneous'].includes(workspace)) {
        const needToRedirect = this.$route.meta.onWorkspaceChangeRedirectTo;

        if (needToRedirect) {
          route = needToRedirect(this.$route);
        }
      }

      if (route) {
        this.$router.push(route);
      }
    }
  }
};
</script>

<style lang="scss">
body { background-color: #F5F5F5; }
#app { background-color: transparent; }

.relative { position: relative; }

.sticky { position: sticky; }
.static { position: static; }

@media (min-width: 959px) {
  .md-and-up-sticky {
    position: sticky !important;
  }
}

.right-0 { right: 0; }

header.v-app-bar.sticky, .sticky {
  position: sticky;
}
header.v-app-bar.v-app-bar, .v-system-bar {
  z-index: 10;
}

#customers-content {
  height: calc(100vh - 117px);
  overflow-y: auto;
}

.selectItem {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: nowrap;
  text-wrap: nowrap;
  overflow: hidden;
  gap: 2px;

}

.selectLabel {
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-input.input-color-black [disabled], .v-input.input-color-black .v-select__selection  {
  color: rgba(0, 0, 0, 0.87);
}
.selectCount {
  background-color: rgba(199, 27, 0, 0.9);
  border-radius: 4px;
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  font-weight:500;
  min-width: 24px;
  height: 24px;
  padding: 0px 3px 0px 3px;
  color: white;
}

#dashboard-table table {
  border-spacing: 0 16px;

  thead tr {
    text-transform: uppercase;

    th {
      border: 0px;

      font-weight: 400;
      font-size: 14px;
    }

    th.active {
      .v-data-table-header__icon { color: #c71900; }
    }

  }
  tbody tr {
    padding: 0 24px;

    background-color: white;

    td {
      border: 0px;

      font-weight: 500;
      font-size: 16px;
    }
  }

  thead tr, tbody tr {
    th:first-child, td:first-child {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      overflow: hidden;
    }
    th:last-child, td:last-child {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      overflow: hidden;

    }
  }
}

.pointer { cursor: pointer; }

.required label::after { content: "*"; }

.v-expansion-panel-content__wrap { padding: 0 !important; }

.persistent-scrollbar::-webkit-scrollbar,
.v-data-table__wrapper::-webkit-scrollbar {
  height: 8px;
}

.persistent-scrollbar::-webkit-scrollbar-track,
.v-data-table__wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.persistent-scrollbar::-webkit-scrollbar-thumb,
.v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.persistent-scrollbar::-webkit-scrollbar-thumb:hover,
.v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.remove-content-padding-y .v-toolbar__content {
  padding-block: 0px;
}

.v-dialog:not(.v-dialog--fullscreen) {
  margin: 16px !important;
}

.break-word {
  overflow-wrap: break-word;
  word-break: break-word;
}
</style>
